module.exports = __webpack_public_path__ + "img/header_icon.e0d7b600.svg";